export default [{
    icon: ['left', 'fal', 'lightbulb-dollar'],
    text: 'Debt Consolidation',
    color: 'purple',
    value: 'debt_consolidation',
    crumb: 'Consolidating Debt'
},
{
    icon: ['left', 'fal', 'money-check-edit-alt'],
    text: 'Paying Bills',
    color: 'orange',
    value: 'pay_bills',
    crumb: 'Paying Bills'
},
{
    icon: ['left', 'fal', 'shopping-cart'],
    text: 'Making a Purchase',
    color: 'lime',
    value: 'make_purchase',
    crumb: 'Making a Purchase'
},
{
    icon: ['left', 'fal', 'hands-usd'],
    text: 'Emergency Cash',
    color: 'yellow',
    value: 'emergency_cash',
    crumb: 'Emergency Cash'
},
{
    icon: ['left', 'fal', 'landmark-alt'],
    text: 'Paying Taxes',
    color: 'blueish',
    value: 'pay_taxes',
    crumb: 'Paying Taxes'
},
{
    icon: ['left', 'fal', 'search-dollar'],
    text: 'Other Reasons',
    color: 'green',
    value: 'other_purpose',
    crumb: 'Other Reasons'
}];